import { createRoot } from "react-dom/client";

console.log('[main.tsx] App mounting. Current URL:', window.location.href)
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { AuthContextProvider } from "./context/AuthContext.tsx";
import { ProfileProvider } from "./context/ProfileContext.tsx";
import { FavoritesProvider } from "./context/FavoritesContext.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <AuthContextProvider>
      <ProfileProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </FavoritesProvider>
      </ProfileProvider>
    </AuthContextProvider>
  </ErrorBoundary>,
);
